import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PickrightToggleComponent } from './toggle-control/toggle-control.component';
import { PickrightRadioComponent } from './radio-control/radio-control.component';
import { PickrightInputComponent } from './input-control/input-control.component';
import { PickrightDropdownComponent } from './dropdown-control/dropdown-control.component';
import { PickrightCheckboxComponent } from './checkbox-control/checkbox-control.component';
import { PickrightLabelComponent } from './control-label/control-label.component';
import { PickrightHintComponent } from './control-hint/control-hint.component';
import { PickrightErrorComponent } from './control-error/control-error.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlFeildErrorPipe } from './control-error.pipe';
import { PickrightEmailComponent } from './email-control/email-control.component';
import { PickrightPasswordComponent } from './password-control/password-control.component';
import { ControlClickOutsideDirectiveModule } from '../../directives/ouside-click.directive';
import { CounterComponent } from './counter/counter.component';
import { SharedIconsModule } from '../shared-icons/shared-icons.module';
import { PickrightAutocompleteComponent } from './autocomplete-control/autocomplete-control.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CollapsableSearchComponent } from './collapsable-search/collapsable-search.component';


@NgModule({
    declarations: [
        PickrightCheckboxComponent,
        PickrightDropdownComponent,
        PickrightRadioComponent,
        PickrightInputComponent,
        PickrightToggleComponent,
        PickrightEmailComponent,
        PickrightPasswordComponent,
        PickrightLabelComponent,
        PickrightHintComponent,
        PickrightErrorComponent,
        ControlFeildErrorPipe,
        CounterComponent,
        PickrightAutocompleteComponent,
        CollapsableSearchComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedIconsModule,
        MatAutocompleteModule,
        ControlClickOutsideDirectiveModule
    ],
    exports: [
        PickrightCheckboxComponent,
        PickrightDropdownComponent,
        PickrightRadioComponent,
        PickrightInputComponent,
        PickrightToggleComponent,
        PickrightEmailComponent,
        PickrightPasswordComponent,
        PickrightLabelComponent,
        PickrightHintComponent,
        PickrightErrorComponent,
        CounterComponent,
        PickrightAutocompleteComponent,
        CollapsableSearchComponent
    ]
})
export class PickrightControlModule { }
